import { mdiArchive, mdiArchiveOutline } from '@mdi/js'
import Icon from '@mdi/react'
import type { IconProps } from '.'

const Archives = (props: IconProps) => {
    const { filled, size = 1, ...other } = props
    return (
        <Icon
            data-testid="IconButton__ChatArchive"
            aria-label="Chat Archive"
            path={filled ? mdiArchive : mdiArchiveOutline}
            size={size}
            {...other}
        />
    )
}

export default Archives
